import { BoxGeometry, Group, Mesh, Vector3, MeshBasicMaterial } from 'three';
import { getContainerBox } from '../utils/objectSize';

export function moveToWorld(object) {
  object.updateWorldMatrix(true, true);
  object.updateMatrixWorld(true);
  object.matrix.copy(object.matrixWorld);
  object.removeFromParent();
  object.matrix.decompose(object.position, object.quaternion, object.scale);
  return object;
}

export function moveToCenter(object, centerAxis = {}) {
  const { x = true, z = true, y = false } = centerAxis;
  const center = getContainerBox(object).getCenter(new Vector3());
  if (x) {
    object.position.x -= center.x;
  }
  if (y) {
    object.position.y -= center.y;
  }
  if (z) {
    object.position.z -= center.z;
  }
  return object;
}

export function withContainer(object) {
  const g = new Group();
  g.add(object);
  return g;
}

const clickHelperMaterial = new MeshBasicMaterial({ colorWrite: false, depthWrite: false });
const clickHelperGeometry = new BoxGeometry(1, 1, 1);

export function withClickHelper(object, padding) {
  const box = getContainerBox(object);
  const center = box.getCenter(new Vector3());
  const objectSize = box.getSize(new Vector3());
  padding && objectSize.add(padding);

  const hole = new Mesh(clickHelperGeometry, clickHelperMaterial);
  hole.scale.copy(objectSize);
  hole.position.copy(center);
  object.add(hole);
  return object;
}
